import formValidateMixin from "../mixins/form-validate";
import ModalMixin from "../mixins/modal";
import Axios from 'axios';
var datestr = function datestr(d) {
  var pad = function pad(x) {
    return x < 10 ? "0".concat(x) : "".concat(x);
  };
  return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()));
};
export default {
  name: "user-register",
  props: ["title", "from", "trial", "value"],
  mixins: [formValidateMixin, ModalMixin],
  data: function data() {
    var vm = this;
    var categories = ["招投标环境", "培训学习", "产品测试", "用户试用", "演示", "其他"];
    var productsMaxLevel = 5; // 产品明细 最深可到达的层级
    return {
      categories: categories,
      products: [],
      productsMaxLevel: productsMaxLevel,
      data: {
        category: categories[0],
        customer: "",
        // 默认明天过期
        expire_date: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000),
        point_num: 1,
        // product: [],
        product: '',
        remark: ""
      },
      rules: {
        category: {
          type: "string",
          required: true,
          min: 2,
          max: 20
        },
        customer: {
          type: "string",
          required: true,
          min: 2,
          max: 20
        },
        expire_date: {
          type: "date",
          required: true
        },
        point_num: {
          type: "number",
          required: true
        },
        // product: {type: "array", required: true, min: productsMaxLevel+1},
        product: {
          type: "number",
          required: true
        },
        remark: {
          type: "string",
          required: true
        }
      },
      options: {
        disabledDate: function disabledDate(date) {
          return date.valueOf() < Date.now() - 86400000 || date.valueOf() > Date.now() + vm.user.max_trial_days * 86400000;
        }
      },
      loading: false
    };
  },
  computed: {
    user: function user() {
      return this.$store.state.user || {};
    }
  },
  methods: {
    onLoad: function onLoad() {
      var _this = this;
      this.$refs.form.resetFields();
      if (this.from === "update") {
        var data = this.trial;
        for (var _i = 0, _arr = ["category", "customer", "point_num", "remark"]; _i < _arr.length; _i++) {
          var key = _arr[_i];
          this.data[key] = data[key];
        }
        this.data.expire_date = new Date(data.expire_date);
        // this.data.product = []; // 不匹配会导致下拉框无法打开
        this.data.product = data.product_details.id;
      }
      this.validate();
      Axios.get("fenxiang/product-details/?pagination=false").then(function (resp) {
        _this.products = resp.data['productdetails'];
        if (_this.products.length === 0) {
          return;
        }
        if (_this.from !== 'update') {
          _this.data.product = _this.products[0].id;
        }
      });

      // this.getProducts('', 0, list => {
      //     // this.products = list;
      //     list.unshift(list.length, 0);
      //     Array.prototype.splice.apply(this.products, list);
      // });
    },
    /*
    ** level 为当前查询节点所处层级，从0开始
    ** 最后一层才为可提交对象（一个），之前都为"文件夹"名（列表）
    */
    getProducts: function getProducts(str, level, callback) {
      var _this2 = this;
      var url = '/pmv5/service/fenxiang/product-details/linkage-menu/';
      url += str;
      var arr = [];
      Axios.get(url).then(function (res) {
        console.log('res', res);
        var data = res.data;
        var code = data.code,
          levelData = data.data;
        var list = [];
        if (code !== 0) {
          callback(list);
          return false;
        }
        if (level <= _this2.productsMaxLevel - 1) {
          levelData.map(function (item) {
            list.push({
              value: encodeURIComponent(item),
              label: item,
              children: [],
              loading: false,
              level: level
            });
          });
          callback(list);
          return false;
        }

        // 最后一层不能继续查子节点，切忌加 loading 属性
        list.push({
          value: encodeURIComponent(levelData.id),
          label: levelData.product_name,
          children: [],
          // loading: false,
          level: level
        });
        callback(list);
        return false;
      }).catch(function (err) {
        console.log('err', err);
      });
    },
    loadData: function loadData(item, callback) {
      // 当前是否在加载中
      item.loading = true;
      var arr = this.data.product.slice(0);
      arr.splice(item.level);
      arr.push(item.value);
      var str = arr.join('/');
      this.getProducts(str, ++item.level, function (list) {
        // item.children = list;
        list.unshift(list.length, 0);
        Array.prototype.splice.apply(item.children, list);
        item.loading = false;
        // 自动展开当前项的子列表
        callback();
      });
    },
    // 仅仅为了实现实时校验
    changeProducts: function changeProducts(value, selectedData) {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.validate('product', '', 'form');
      });
    },
    handleOk: function handleOk() {
      var _this4 = this;
      var data = this.data;

      // 万恶的表单校验之数字
      var point_num = data.point_num;
      if (isNaN(point_num) || point_num < 1 || point_num > this.user.max_point_num) {
        this.$Message.error("\u8BD5\u7528\u70B9\u6570\u5FC5\u987B\u57281-".concat(this.user.max_point_num, "\u4E4B\u95F4!"));
        return;
      }
      this.loading = true;
      var method = this.from === "update" ? "put" : "post";
      var url = this.from === "update" ? "trials/".concat(this.trial.id, "/") : "trials/";
      return Axios[method](url, {
        category: data.category,
        customer: data.customer,
        expire_date: datestr(data.expire_date),
        point_num: data.point_num,
        remark: data.remark,
        // product_details: data.product[data.product.length-1]
        product_details: data.product
      }).then(function () {
        return _this4.loading = false;
      }, function (e) {
        _this4.loading = false;
        throw e;
      });
    },
    resetData: function resetData() {
      this.$refs.form.resetFields();
      this.loading = false;
      this.validate();
    }
  }
};